var modules_034cfbf6 = {"container":"AppBanner_module_container__7a595dd7","qrWrapper":"AppBanner_module_qrWrapper__7a595dd7","titleContainer":"AppBanner_module_titleContainer__7a595dd7","appImg":"AppBanner_module_appImg__7a595dd7","stub":"AppBanner_module_stub__7a595dd7"};
import "../../../assets/BuWOi79v.css";

export { modules_034cfbf6 as default };
//# sourceMappingURL=AppBanner.module.less.js.map
